import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ISport } from 'bets.oddprovider.lib.common.ts/models'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { SportsApiClient } from '../../apiClient/sports'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface ISportsAction extends IDefaultAction {
  payload?: ISport[],
}

export interface ISportsState extends IDefaultState {
  payload?: ISport[],
}

const initState: ISportsState = {}

export const sportsStateLoadFromApi = createAsyncThunk(
  'sportsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<ISport>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<ISport>> = await new SportsApiClient(axios).get({
      where: arg.where,
      sort: { name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const sportsSlice = createSlice({
  name: 'sportsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(sportsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(sportsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(sportsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearSports} = sportsSlice.actions
export default sportsSlice.reducer